/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import { Checkbox } from 'antd'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setContractTypes } from '../../../../../../redux/reducers/talentSlice'
import { contractTypes } from '../../../../../../utils/utils'
import * as s from './ContractType.styles'

const propTypes = {
  required: PropTypes.bool,
}
const defaultProps = {
  required: false,
}

function ContractType({ required }) {
  const { t } = useTranslation(['talentArea', 'campaign'], {
    useSuspense: false,
  })
  const dispatch = useDispatch()
  const { contractTypes: contracts } = useSelector((state) => state.talent)

  const [selectedContracts, setSelectedContracts] = useState([])

  useEffect(() => {
    if (contracts.length > 0) {
      setSelectedContracts(contracts)
    }
  }, [contracts])

  /**
   * Update contract talent selection array
   * @param {string} value contract type to add/remove
   */
  const handleContractTypeChange = (value) => {
    setSelectedContracts(value)
    dispatch(setContractTypes(value))
  }

  const ContractCheckbox = ({ value, children }) => (
    <Checkbox value={value} defaultChecked>
      {children}
    </Checkbox>
  )

  return (
    <s.ContractTypeWrapper data-cy="contract-fields">
      <label className="field-label">
        {t(
          'talentArea:profile.contractType.label',
          'Type de contrat recherché',
        )}
        {required && <span className="required">*</span>}
      </label>
      <Checkbox.Group
        onChange={handleContractTypeChange}
        defaultValue={selectedContracts}
        value={selectedContracts}
      >
        {contractTypes(t).map((type) => (
          <ContractCheckbox key={type.value} value={type.value}>
            {type.label}
          </ContractCheckbox>
        ))}
      </Checkbox.Group>
    </s.ContractTypeWrapper>
  )
}

ContractType.propTypes = propTypes
ContractType.defaultProps = defaultProps

export default ContractType
